import { render, staticRenderFns } from "./leftPageYb.vue?vue&type=template&id=7f2f5d94&scoped=true&"
import script from "./leftPageYb.vue?vue&type=script&lang=js&"
export * from "./leftPageYb.vue?vue&type=script&lang=js&"
import style0 from "./leftPageYb.vue?vue&type=style&index=0&id=7f2f5d94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2f5d94",
  null
  
)

export default component.exports